import { formatMoney } from '@aeris/money';
import { isEan13 } from "./barcode.js";
/**
 * Onde o nome é cortado.
 *
 * Não é o tamanho do adesivo — é o ponto em que o nome deixa de identificar o
 * produto e passa a ser ruído. "Camiseta Polo Piquet Masculina Manga Curta Azul
 * Marinho Tamanho G" cabe em duas linhas de corpo pequeno e ninguém lê; o CSS
 * ainda limita a duas linhas por cima disto, mas o corte decidido aqui é o que
 * aparece igual na pré-visualização e no papel.
 */
const NAME_MAX = 60;
const truncateName = (name) => {
    const trimmed = name.trim();
    if (trimmed.length <= NAME_MAX)
        return trimmed;
    // O reticências entra NO lugar do último caractere, não depois — senão o
    // corte de 60 devolve 61.
    return `${trimmed.slice(0, NAME_MAX - 1).trimEnd()}…`;
};
export const labelFor = (input, fields) => {
    const blocks = [];
    if (fields.showName && input.name.trim() !== '') {
        blocks.push({
            kind: 'text',
            text: truncateName(input.name),
            align: 'center',
        });
    }
    const gtin = input.gtin?.trim();
    const usesGtin = gtin !== undefined && gtin !== '';
    const barcodePrinted = fields.showBarcode && (usesGtin || input.sku !== '');
    if (barcodePrinted) {
        /*
         * Quem decide a simbologia é o DADO — F168.
         *
         * Nem todo código de barras é um EAN-13. Os 5.531 produtos que vieram do
         * sistema antigo trazem o número da etiqueta da prateleira (`40`,
         * `0000000000010`), sem dígito verificador: pedir um EAN-13 ali fazia o
         * desenho do símbolo lançar, e a folha inteira de etiquetas não saía.
         * CODE128 lê qualquer um deles, que é o que o leitor do balcão precisa.
         */
        blocks.push(usesGtin
            ? isEan13(gtin)
                ? { kind: 'barcode', symbology: 'ean13', data: gtin }
                : { kind: 'barcode', symbology: 'code128', data: gtin }
            : { kind: 'barcode', symbology: 'code128', data: input.sku });
    }
    // Só quando acrescenta: o CODE128 do SKU já escreve o SKU embaixo das barras.
    const skuIsRedundant = barcodePrinted && !usesGtin;
    if (fields.showSku && input.sku !== '' && !skuIsRedundant) {
        blocks.push({ kind: 'text', text: input.sku, align: 'center' });
    }
    /*
     * Preço ausente não vira zero.
     *
     * Um produto recém-cadastrado sem preço de venda existe (F123: preço é
     * opcional). Imprimir `R$ 0,00` põe no papel um número que alguém vai cobrar
     * — e é mais barato descobrir o preço faltando por um adesivo sem preço do
     * que por uma venda a zero.
     */
    if (fields.showPrice && input.price != null) {
        blocks.push({
            kind: 'text',
            text: formatMoney(input.price),
            align: 'center',
            big: true,
            bold: true,
        });
    }
    return {
        kind: 'label',
        title: `Etiqueta — ${input.sku === '' ? input.name : input.sku}`,
        blocks,
    };
};
//# sourceMappingURL=label.js.map